import styled from 'styled-components'

export const TextContainer = styled.p`
    display: -webkit-box;

    line-height: 14px;
    font-size: 14px;
    -webkit-line-clamp: 6;
    height: calc(14px * 6);

    -webkit-box-orient: vertical;
    overflow: hidden;
    font-family: ${({ theme }) => theme['font-bold']};
    color: #fff;
    margin: 0;
`
